function Expand({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg  width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 8V0H10L13.29 3.29L3.29 13.29L0 10V18H8L4.71 14.71L14.71 4.71L18 8Z"  fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Expand;
